import { render, staticRenderFns } from "./OrderManagment.vue?vue&type=template&id=2f218342&scoped=true&"
import script from "./OrderManagment.vue?vue&type=script&lang=js&"
export * from "./OrderManagment.vue?vue&type=script&lang=js&"
import style0 from "./OrderManagment.vue?vue&type=style&index=0&id=2f218342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f218342",
  null
  
)

export default component.exports